import React from 'react'
import Menu_Home_bar from './Menu_Home_bar';
import Name_Section from './Name_Section';


const Menu = () => {
    return (
    <>
    <div className='menu'>
        <Menu_Home_bar/>  
        <Name_Section/>    
    </div>
    </>
  )
}

export default Menu;
